import { render } from "./Link1.vue?vue&type=template&id=07972ca6"
import script from "./Link1.vue?vue&type=script&lang=ts"
export * from "./Link1.vue?vue&type=script&lang=ts"

import "./Link1.vue?vue&type=style&index=0&id=07972ca6&lang=scss"
script.render = render

export default script